import { createContext } from "react";

import { DocumentsService } from "types";
import { ServiceContextType } from "types/common/context";

const defaultService: DocumentsService = {
	getDocuments() {
		throw new Error("service.getDocuments not implemented");
	},
	addDocument() {
		throw new Error("service.addDocument not implemented");
	},
	deleteDocument() {
		throw new Error("service.deleteDocument not implemented");
	},
	viewDocument() {
		throw new Error("service.viewDocument not implemented");
	},
	downloadDocument() {
		throw new Error("service.downloadDocument not implemented");
	},
};

export type DocumentsServiceContextType = ServiceContextType<DocumentsService>;

const DocumentsServiceContext = createContext<DocumentsServiceContextType>({
	key: "default",
	service: defaultService,
});

export default DocumentsServiceContext;
